export default {"src":"/_next/static/media/invention.a32e53e3.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};